import { ROUTE_NAMES } from '@atlassian/jira-common-constants/src/spa-routes-legacy-do-not-use';

export const userSegmentationRoute = {
	name: ROUTE_NAMES.USER_SEGMENTATION,
	path: '/jira/get-started',
	exact: true,
};
